import {
  contrastChecker,
  getCssPropertyValue,
  setCssPropertyValue
} from '../../ts/helper';

export const blockChart = () => {
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll('[is="block-chart"]')
  );

  components.forEach((component) => {
    const handleBorderColor = () => {
      const listItems: HTMLElement[] = Array.from(
        component.querySelectorAll('.list-item')
      );

      /** Background HEX color of this {@link component} */
      const background = component.classList.contains('backgroundOne')
        ? '#ffffff'
        : '#eff6fc';

      listItems.forEach((listItem) => {
        /** This is the bullet color of the {@link listItem} */
        const color = getCssPropertyValue(
          '--block-chart-list-item-bullet-color',
          listItem
        ).trim();

        /** We need to check, if the color is perceivable on the chosen {@link background} */
        const colorIsPerceivable = contrastChecker(
          color,
          background,
          'AA-level large text'
        );

        if (!colorIsPerceivable) {
          /** If the contrast is to low, we add a black border around the bullet, making sure it is perfectly visible. */
          setCssPropertyValue(
            '--block-chart-list-item-bullet-border-color',
            '#929292', // we do not need a 100% opaque color, since this is not actually text, but a graphical element
            listItem
          );
        }
      });
    };

    handleBorderColor();
  });
};
